import { useStaticQuery, graphql } from "gatsby"

export const useProductContent = () => {
  const { products } = useStaticQuery(graphql`
    query PRODUCT_CONTENT {
      products: allSanityProduct(filter: { shopify: { shopifyDeleted: { ne: true }, shopifyPublished: { eq: true } } }) {
        edges {
          node {
            id
            title
            productType
            tags
            shopify {
              id: shopifyId
              handle: shopifyHandle
            }
          }
        }
      }
    }
  `)

  const items = products?.edges?.map(({ node }) => node) || []

  const getProductsByTag = tags => items?.filter(item => tags?.every(value => item.tags?.includes(value)))
  const getPackProductsByTagHandle = handles => items?.filter(item => handles?.every(value => item.tags?.includes(`packGroup:${value}`)))

  return {
    items,
    getProductsByTag,
    getPackProductsByTagHandle,
  }
}
